/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ row: NonNullable<unknown> }} Order_Row_Remove_LabelInputs */

const vi_order_row_remove_label = /** @type {(inputs: Order_Row_Remove_LabelInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Xóa dòng ${i?.row}`)
};

/**

* @param {Order_Row_Remove_LabelInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const order_row_remove_label = /** @type {((inputs: Order_Row_Remove_LabelInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Order_Row_Remove_LabelInputs, { locale?: "vi" }, {}>} */ ((inputs, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_order_row_remove_label(inputs)
});